import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { Control, PhoneCompatibility } from '../../models/Flow';
import { Router } from '@angular/router';
import { Utilities } from '../../utilities';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TileComponent implements OnInit {
  @Input() control: Control;
  @Input() compatible: PhoneCompatibility;
  public appBase = TCCPConstantValues[environment.applicationName];
  public controlIcon: any;
  public urlPath = Utilities.GetLastPath(this.router.url);
  public image = '';

  // IMAGE_COMMON_PATH
  public imageExtension: string = this.appBase.FIXED_VALUES.SVG_EXTENSION;
  public imagePath: SafeUrl;
  public link = 'dashboard';
  public controlContent;
  // public note = { content : "abcdef"};
  public tip = '';
  public isToyota: boolean;
  public draftOption: string;
  public newBannerImageURL = `${environment.baseURL}content/${environment.applicationName}/common/new_Banner.png`;

  constructor(public router: Router, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    console.log('this.control', this.control);
    this.isToyota = Utilities.GetPath(this.router.url) === 'toyota' ? true : false;
    if (this.control && this.control.status === 'draft') {
      this.draftOption = (
                          this.control.draftCategory &&
                          this.control.draftCategory.draftCategory &&
                          this.control.draftCategory.draftCategory === 'comingSoon'
                         ) ? 'Coming Soon' : 'Under Maintenance';
      this.tip = (
                  this.control.draftCategory &&
                  this.control.draftCategory.draftMessage &&
                  this.control.draftCategory.draftMessage !== ''
                 ) ? this.control.draftCategory.draftMessage :
                     'We are sorry.  \n This Support Topic is currently under maintenance. \n Please check back in a few hours.';
    }
    if (this.compatible) {
      this.control = < Control > {};
      this.control.controlName = this.compatible.displayName;
      if(this.compatible && this.compatible.icon){
        this.control.icon=this.compatible.icon}
    }
    this.imagePath = this.appBase.Urls.SVG_PATH + this.control.icon;
    const controlContent = document.querySelector('.card-text');
    this.controlContent = controlContent.clientHeight;
  }

  hideTooltipIn(tooltip: MatTooltip, ms: number) {
    tooltip.toggle();
    setTimeout(() => tooltip.hide(), ms);
  }

  mouseEnter(e, status) {
    if (e.target && status !== 'draft') {
      e.target.classList.add('active');
    } else {
      console.log(e.target.classList);
      e.target.classList.remove('active');
      e.target.classList.remove('cursor');
    }
  }
  mouseLeave(e) {
    if (e.target) {
      e.target.classList.remove('active');
    }
  }




  showNewIcon(feature) {
    const currentDate = new Date(new Date().toUTCString());
    if (
        feature.firstPublishedDate !== undefined &&
        feature.firstPublishedDate &&
        feature.firstPublishedDate !== '' &&
        feature.status === 'published') {
      const uploadDate = new Date(feature.firstPublishedDate);
      const datediff = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(),
        currentDate.getDate()) - Date.UTC(uploadDate.getFullYear(), uploadDate.getMonth(), uploadDate.getDate())) / (1000 * 60 * 60 * 24));
      if (datediff < 30) {
        return true;
      }
      return false ;
    } else {
      return false ;
    }
  }

}
